/** @import modules */

import { useTranslation }           from "react-i18next";

/** @import icons */

import { BsFillTelephoneFill }      from "react-icons/bs";

import { 
    
    FaMobileAlt, 
    
    FaEnvelope }                    from "react-icons/fa";

const formatClock = ( time ) => {

    if ( ! time || typeof time !== "string" ) return null;

    return time.replace ( "-", ":" );

};

const formatRange = ( start, end, closedLabel ) => {

    if ( ! start || ! end || ( start === "00-00" && end === "00-00" ) ) {

        return closedLabel;

    }

    const from = formatClock ( start );

    const to = formatClock ( end );

    if ( ! from || ! to ) return closedLabel;

    return `${ from } - ${ to }`;

};

const ContactsInformation = ( { data } ) => { const

    { t } = useTranslation (),

    contacts = [

        { icon: <BsFillTelephoneFill />,    name: t ( "shop_name" ),        value: data.contacts?.phone,            prefix: "tel:"      },

        { icon: <FaMobileAlt />,            name: t ( "service_phone" ),    value: data.contacts?.servicePhone,     prefix: "tel:"      },

        { icon: <FaEnvelope />,             name: t ( "email" ),            value: data.contacts?.email,            prefix: "mailto:"   }

    ],

    hours = data?.hours,

    Collection = ( { params } ) => <ul>{ 
        
        params.map ( ( info, index ) => <li key={ index }>

            <span>{ info.icon }</span>

            { `${ info.name }:` } <a href={ `${ info.prefix }${ info.value }` }>{ info.value }</a>

        </li> ) }
        
    </ul>, 

    Hours = ( { params } ) => {

        if ( ! params ) return null;

        const closed = t ( "closed" );

        const weekday = formatRange ( params.startTimeMonday, params.endTimeMonday, closed );

        const saturday = formatRange ( params.startTimeSaturday, params.endTimeSaturday, closed );

        const sunday = formatRange ( params.startTimeSunday, params.endTimeSunday, closed );

        return <div className="content">

            <ul>

                <li>{ t ( "weekdays" ) } { weekday }</li>

                <li>{ t ( "saturday" ) }: { saturday }</li>

                <li>{ t ( "sunday" ) }: { sunday }</li>
                
            </ul>

        </div>

    };

    /** @return component */

    return ( <div className="office-info">

        <div className="communication">

            <div className="headline">{ t ( "contact_information" ) }</div>

            <div className="content">

                <Collection params={ contacts } />

            </div>

        </div>

        <div className="hours">

            <div className="headline">{ t ( "work_hours" ) }</div>

            <Hours params={ hours } />

        </div>

    </div> );

}
 
/** @export ContactsInformation */

export default ContactsInformation;
